import React from 'react';
import { FadeIn } from './FadeIn';
export function AgitationSection() {
  const questions = ['¿Cuántas veces esta semana empezaste un informe semestral desde cero porque no tenés un modelo que funcione?', '¿Cuántas facturas de obra social te rechazaron por un error en la planilla de asistencia o en la documentación?', '¿Cuántas veces dijiste "te mando las pautas" y las escribiste esa noche porque no tenés nada preparado?', '¿Cuántos primeros WhatsApp a familias nuevas tardaste más en escribir que en dar la primera sesión?', '¿Cuántas veces buscaste en el celular el modelo de consentimiento informado y no lo encontraste?'];
  return <section className="bg-brand-cream pb-16 md:pb-24 px-4 md:px-6" data-id="element-14">
      <div className="max-w-3xl mx-auto" data-id="element-15">
        <FadeIn data-id="element-16">
          <p className="text-brand-dark text-[17px] md:text-lg font-semibold mb-6" data-id="element-17">
            ¿Te suena familiar alguna de estas situaciones?
          </p>
        </FadeIn>

        <div className="space-y-4" data-id="element-18">
          {questions.map((q, i) => <FadeIn key={i} delay={i * 0.08} data-id="element-19">
              <div className="bg-brand-white border-l-[3px] border-brand-green rounded-r-lg px-6 py-5 text-brand-dark text-[15px] md:text-base leading-relaxed shadow-sm" data-id="element-20">
                {q}
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-21">
          <div className="mt-10 md:mt-12 pt-8 border-t border-brand-cream-dark text-brand-muted text-[16px] md:text-[17px] leading-[1.8]" data-id="element-22">
            No es que seas desorganizada. Es que{' '}
            <strong className="text-brand-green font-semibold" data-id="element-23">
              nadie te dio las herramientas.
            </strong>{' '}
            En la facultad te enseñaron a evaluar y a tratar. A documentar el
            consultorio, a facturar obras sociales, a gestionar el encuadre con
            las familias — eso tuviste que aprenderlo sola.{' '}
            <strong className="text-brand-green font-semibold" data-id="element-24">
              Hasta ahora.
            </strong>
          </div>
        </FadeIn>
      </div>
    </section>;
}